/*
*
*  It just customization for Material UI Grid. With custom sizes according to https://ipawn1.atlassian.net/browse/WORTHY-9572 jira
* Usage: in order to use this enhancer you should import this and wrap your component
* Export from your component will look like this: export default withMaterialUITheme(YourComponent)
*
* */

import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    spacing: 6,
    breakpoints: {
        values: {
            sm: 600,
            md: 1024,
            lg: 1440,
        },
    },
});

export default (Component) => (props) => (
    <ThemeProvider theme={theme}>
        <Component {...props} />
    </ThemeProvider>
);
